// ARCHIVO GENERADO — no lo edites a mano.
// Lo escribe scripts/generate-version.js en cada build (prebuild / prestart).
export const APP_VERSION = '1.0.0';
export const APP_BUILD_ID = '1.0.0-1a2407e-mvhn6sxi';
export const APP_BUILD_DATE = '2026-10-21T04:58:55.819Z';
